export interface XsosPdaHardwareBridge {
  setInfraredScannerEnabled?: (enabled: boolean) => boolean | void | Promise<boolean | void>;
  setScannerEnabled?: (enabled: boolean) => boolean | void | Promise<boolean | void>;
}

declare global {
  interface Window {
    XSOSPdaHardware?: XsosPdaHardwareBridge;
  }
}

/**
 * Ask the native PDA host to switch the SE4710 scanner engine.
 *
 * The YK927 HCScan service expects the native host to translate this call to:
 * - enabled=false -> com.atao.action.SCAN_SERVICE, state="1"
 * - enabled=true  -> com.atao.action.SCAN_SERVICE, state="0"
 *
 * A normal browser cannot send Android broadcasts, so absence of the bridge is
 * intentionally treated as a supported no-op and the firmware fallback remains active.
 */
export async function setPdaInfraredScannerEnabled(enabled: boolean) {
  const bridge = window.XSOSPdaHardware;
  const setter = bridge?.setInfraredScannerEnabled || bridge?.setScannerEnabled;
  if (!setter || !bridge) {
    return false;
  }

  try {
    await setter.call(bridge, enabled);
    return true;
  } catch {
    return false;
  }
}

